import { MultiLevelNavigation } from '@components/Base/MultiLevelNavigation/MultiLevelNavigation'
import { IMultiLevelMenu } from '@interfaces/interfaces'
import HelpIcon from '@mui/icons-material/Help'
import SettingsIcon from '@mui/icons-material/Settings'
import React from 'react'

const settingsMenu: IMultiLevelMenu = {
  isDownArrow: false,
  heading: <SettingsIcon fontSize='small' />,
  isMenuList: true,
  menuGroups: [
    {
      menuList: [
        {
          page: 'Access Agreement',
          route: '/settings/access-agreement',
        },
      ],
    },
  ],
  divider: [
    {
      page: 'Knowledge Center',
      route: '/knowledge-center',
      icon: <HelpIcon />,
    },
  ],
}

export const AppSettings: React.FunctionComponent = () => {
  return (
    <MultiLevelNavigation multiLevelMenu={settingsMenu}></MultiLevelNavigation>
  )
}
